import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { AuthService } from '../../../core/auth.service';
import { PopoverService } from '../../../shared/popover/popover.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'diagnosis-modal-component',
    templateUrl: './diagnosis-modal.component.html',
    styleUrls: ['./diagnosis-modal.component.scss'],
})
export class DiagnosisModalComponent implements OnChanges {
    @Input() params: Object;
    @Input() formLoading: boolean;
    @Input() form: FormGroup;
    @Input() formSubmitted: boolean;
    @Input() languages: Object[];
    @Input() itemLanguage: string;
    @Input() parentDiagnosis: Object[];
    @Input() authService: AuthService;
    @Input() helpRawData = '';

    @Output() hideModal = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();
    @Output() openFormModal = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();

    @ViewChild('formDirective') private formDirective: NgForm;

    listDiagnosis = [];
    levels = [
        {
            name: '1',
            value: 1
        },
        {
            name: '2',
            value: 2
        },
        {
            name: '3',
            value: 3
        }
    ];

    constructor(
        public popoverService: PopoverService,
        public translate: TranslateService,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['params'] && this.formDirective) {
            this.formDirective.resetForm();
        }

        this.listDiagnosis = this.parentDiagnosis;
        // set helpTemplates
        this.popoverService.setHelpContent(this.helpRawData);

        if (this.form && this.form.controls['level'].value) {
            this.updateDiagnosisList(this.form.controls['level'].value);
        }

    }

    updateDiagnosisList(value) {
        this.listDiagnosis = [];
        if (isNaN(value)) {
            return;
        }

        this.parentDiagnosis.forEach(diagnosis => {
            if (diagnosis['level'] === (parseInt(value) - 1)) {
                this.listDiagnosis.push(diagnosis);
            }
        });
    }
}
